<div class="container">
  <mic-breadcrumb id="reject-reasons-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('rejectReasonsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title reject-reasons-heading" id="reject-reasons-heading">
    {{ translationService.translate('rejectReasonsText') }}
  </h2>

  <div class="action-bar">
    <button id="reset-filters" type="button" mat-flat-button color="accent" class="btn-clear" (click)="resetFilters()">
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearSelectionText') }}
    </button>
    <span
      [matTooltip]="
        productSaveDisabled
          ? this.translationService.translate('comingSoonText')
          : !saveEnabled
          ? this.translationService.translate('userCannotSaveText')
          : !isModified
          ? this.translationService.translate('noModifiedText')
          : null
      "
      matTooltipPosition="above"
    >
      <button
        id="save"
        type="button"
        mat-flat-button
        color="primary"
        class="btn-primary"
        (click)="save()"
        [disabled]="!saveEnabled || !isModified"
      >
        <mat-icon>save</mat-icon>
        {{ translationService.translate('saveLinkText') }}
      </button>
    </span>
    <button mat-flat-button color="primary" class="btn-export" (click)="openExportModal()">
      <mat-icon>download</mat-icon>
      {{ translationService.translate('exportButtonText') }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <app-dropdown-search-single-select
          id="rejectReasonDropdown"
          label="{{ translationService.translate('rejectReasonText') }}"
          emptyPlaceholder="{{ translationService.translate('searchByRejectReasonText') }}"
          placeholder="{{ translationService.translate('searchByRejectReasonText') }}"
          [formGroup]="filterForm"
          formControlName="rejectReasons"
          [data]="rejectReasonsFilterList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="rejectReasonDescriptionDropdown"
          label="{{ translationService.translate('searchByRejectReasonText') }}"
          emptyPlaceholder="{{ translationService.translate('searchByRejectReasonDescriptionText') }}"
          placeholder="{{ translationService.translate('searchByRejectReasonDescriptionText') }}"
          [formGroup]="filterForm"
          formControlName="rejectDescriptions"
          [data]="rejectDescriptionFilterList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="rejectCodeTypeDropdown"
          label="{{ translationService.translate('rejectCodeTypeText') }}"
          emptyPlaceholder="{{ translationService.translate('searchByRejectCodeTypeText') }}"
          placeholder="{{ translationService.translate('searchByRejectCodeTypeText') }}"
          [formGroup]="filterForm"
          formControlName="codeTypes"
          [data]="codeTypeFilterList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="failureTypeDropdown"
          label="{{ translationService.translate('failureTypeText') }}"
          emptyPlaceholder="{{ translationService.translate('searchByFailureTypeText') }}"
          placeholder="{{ translationService.translate('searchByFailureTypeText') }}"
          [formGroup]="filterForm"
          formControlName="failureTypes"
          [data]="failureTypeFilterList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="activeDropdown"
          label="{{ translationService.translate('activeText') }}"
          emptyPlaceholder="{{ translationService.translate('searchByStatusText') }}"
          placeholder="{{ translationService.translate('searchByStatusText') }}"
          [formGroup]="filterForm"
          formControlName="active"
          [data]="activeFilterList"
        >
        </app-dropdown-search-single-select>
      </div>
    </form>
  </mat-card>

  <div id="reject-reasons-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'returnDispPartNum'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="{{ translationService.translate('noDataFoundText') }}"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="finishedPartNumberList"
          [formControl]="getControl(item, 'returnDispPartNum')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'scrapDispPartNum'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="{{ translationService.translate('noDataFoundText') }}"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="finishedPartNumberList"
          [formControl]="getControl(item, 'scrapDispPartNum')"
        ></mic-dropdown-search>
      </ng-container>
    </mic-table>
  </div>

  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
